<template>
    <div>
        <h1>{{message}}</h1>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Lien Ag2035'
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        },
        mounted() {

        }

        ,
        created() {

        }

    });
</script>